import React, { Component } from 'react';
import Dashboard from '../Dashboard';

import styles from './styles';

class Home extends Component {
  render() {
    return (
      <Dashboard title="">
        <div style={styles.welcome}>
          <div>Welcome</div>
          <div>to</div>
          <img src="/images/logo-inverse.png" alt="Logo"/>
        </div>
      </Dashboard>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home/index.js